import React from 'react';
import { GameProvider, useGame } from './contexts/GameContext';
import { ThemeProvider } from './contexts/ThemeContext';
import MainMenu from './components/MainMenu';
import GameRoom from './components/GameRoom';

const AppContent: React.FC = () => {
  const { gameState } = useGame();

  return (
    <>
      {!gameState ? <MainMenu /> : <GameRoom />}
    </>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <GameProvider>
        <AppContent />
      </GameProvider>
    </ThemeProvider>
  );
};

export default App;
